class RandomAnimation {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        setTimeout(() => {
            this.init()
        }, 5000)
    }
    init() {
        document.querySelectorAll('[data-random-animation]').forEach((el) => {
            new RandomAnimationGroup(el, this)
        })
    }
}

class RandomAnimationGroup {
    constructor(el, parent){
        this.el = el
        this.parent = parent
        this.items = this.el.querySelectorAll('[data-random-animation-item]')
        this.init()
    }
    init() {
        const randomItems = []
        for (let i = 0; i < 2; i++) {
            const randomItem = this.items[Math.floor(Math.random() * this.items.length)]
            if (randomItems.indexOf(randomItem) === -1) {
                randomItems.push(randomItem)
            } else {
                i--
            }
        }
        let randomDelay = Math.floor(Math.random() * (5000 - 1000 + 1)) + 1000
        this.initItem(randomItems[0], randomItems)
        setTimeout(() => {
            this.initItem(randomItems[1], randomItems)
        }, randomDelay)
    }
    initItem(elItem, randomItems) {
        new RandomAnimationItem(elItem, this.el, () => {
            const index = randomItems.indexOf(elItem)
            if (index > -1) {
                randomItems.splice(index, 1)
            }
            if (randomItems.length === 0) {
                this.init()
            }
        })
    }
}

class RandomAnimationItem {
    constructor(el, parent, callbackEnd) {
        this.el = el
        this.parent = parent
        this.class = this.parent.dataset.randomAnimation
        this.callbackEnd = callbackEnd
        this.init()
    }
    init() {
        let randomDelay = Math.floor(Math.random() * (20000 - 10000 + 1)) + 10000
        this.el.classList.add(this.class)
        setTimeout(() => {
            this.el.classList.remove(this.class)
            setTimeout(() => {
                if (this.callbackEnd) {
                    this.callbackEnd()
                }
            }, 1000)
        }, randomDelay)
    }
}

export default RandomAnimation